import React from "react";

function About() {
  return (
    <section className="about">
      <div className="about__left">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 600">
          <defs>
            {/* <style>
      .cls-1 {
        fill-rule: evenodd;
      }
    </style> */}
          </defs>
          <path
            class="cls-1"
            d="M348.966,185.028C352.5,133.656,390.75,98.4,408.679,84.919c65.653-49.37,156.979-31.683,212.511,6.147,66.582,45.359,84.381,124.626,87.814,168.6,11.7,149.93-115.48,312.737-230.073,307.349-36.811-1.731-88.125-21.605-104.5-62.348-21.744-54.1,38.923-101.571,32.491-167.725C400.873,274.711,344.529,249.615,348.966,185.028Z"
          />
        </svg>
        <img className="about__img" src="/img/faysal Untitled-1.png" />
      </div>

      <div className="about__right">
        <span>My Name is Faysal Mridha</span>
        <h3>About Me</h3>
        <h4>A story of hardword and Perserverance</h4>
        <p>
          {" "}
          I'm a self-learned Front End Software Developer .who's looking for new
          challenges and to become more well-rounded. Web development and new
          technologies are my passion since my early few years.
        </p>
        <h4>Contact</h4>
        <p>
          Feel free to contact me if you think I might be a fit for your team.
        </p>
        <div className="buttons">
          <a
            className="btn"
            href="https://www.linkedin.com/in/faysaldev/"
            target="_blank"
          >
            Hire me
          </a>
          <a
            className="btn outline"
            href="https://docs.google.com/document/d/10aAcNRUmIcAJMwP9052_85xBSk1_xjD_jgBbH8WQz2w/edit?usp=sharing"
            target="_blank"
          >
            Download
          </a>
        </div>
      </div>
    </section>
  );
}

export default About;
